package tta.destinigo.talktoastro.notification

actual class NotificationManagerWrapper actual constructor() : NotificationPermissionManager {

    private val jsPermissionManager:JsPermissionManager = JsPermissionManager()

    override fun requestPermission(): Boolean {
        return jsPermissionManager.requestPermission()
    }

    override fun isPermissionGranted(): Boolean {
        return jsPermissionManager.isPermissionGranted()
    }
}